import React, { useEffect, useState } from "react";
import {
  Row,
  Table,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
  Collapse,
  Card,
  CardBody,
} from "reactstrap";
import { Colxx, Separator } from "components/common/CustomBootstrap";
import Pagination from "containers/pages/Pagination";
import { useSortBy, useTable } from "react-table";

const pageSizes = [30, 50, 100];

const ListingTable2 = ({
  columns,
  data,
  totalItemCount,
  handleSearch,
  loading,
  currentPage,
  setCurrentPage,
  totalPage,
  selectedPageSize,
  setSelectedPageSize,
  searchValues = {},
  withNumeration = true,
  onBatchSelect,
  rowIdAccessor = "_id",
  enableBatchSelect = false,
}) => {
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedPageSize]);

  useEffect(() => {
    handleSearch(currentPage, selectedPageSize, searchValues);
  }, [selectedPageSize, currentPage]);

  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data,
      },
      useSortBy
    );

  // Handle select all
  const isAllSelected =
    rows.length > 0 && selectedRowIds.length === rows.length;
  const isIndeterminate =
    selectedRowIds.length > 0 && selectedRowIds.length < rows.length;

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = rows.map((row) => row.original[rowIdAccessor]);
      setSelectedRowIds(allIds);
      onBatchSelect && onBatchSelect(allIds);
    } else {
      setSelectedRowIds([]);
      onBatchSelect && onBatchSelect([]);
    }
  };

  const handleSelectRow = (id) => (e) => {
    let newSelected;
    if (e.target.checked) {
      newSelected = [...selectedRowIds, id];
    } else {
      newSelected = selectedRowIds.filter((sid) => sid !== id);
    }
    setSelectedRowIds(newSelected);
    onBatchSelect && onBatchSelect(newSelected);
  };

  return (
    <>
      <Row className="listing-top-options">
        <Colxx xxs="12">
          <div className="mb-2">
            <Collapse isOpen className="d-md-block" id="displayOptions">
              <div className="d-block d-md-inline-block pt-1"></div>
              <div className="float-md-right pt-1">
                <span className="text-muted text-small mr-1">
                  {startIndex + 1}-
                  {totalItemCount >= endIndex ? endIndex : totalItemCount}
                  {` of `}
                  {totalItemCount}
                </span>
                <UncontrolledDropdown className="d-inline-block">
                  <DropdownToggle caret color="outline-dark" size="xs">
                    {selectedPageSize}
                  </DropdownToggle>
                  <DropdownMenu end>
                    {pageSizes.map((size, index) => {
                      return (
                        <DropdownItem
                          key={index}
                          onClick={() => setSelectedPageSize(size)}
                        >
                          {size}
                        </DropdownItem>
                      );
                    })}
                  </DropdownMenu>
                </UncontrolledDropdown>
              </div>
            </Collapse>
          </div>
        </Colxx>
      </Row>
      <Row>
        <Colxx xxs="12">
          <Card>
            <CardBody>
              <div className="loading" hidden={!loading} />
              <Table
                responsive
                striped
                {...getTableProps()}
                className={`r-table table text-left`}
              >
                <thead>
                  <tr>
                    {enableBatchSelect && (
                      <th>
                        <input
                          type="checkbox"
                          checked={isAllSelected}
                          ref={(el) => {
                            if (el) el.indeterminate = isIndeterminate;
                          }}
                          onChange={handleSelectAll}
                        />
                      </th>
                    )}
                    {headerGroups[0].headers.map((column, columnIndex) => (
                      <th
                        key={`th_${columnIndex}`}
                        {...column.getHeaderProps(
                          column.getSortByToggleProps()
                        )}
                        className={
                          column.isSorted
                            ? column.isSortedDesc
                              ? "sorted-desc"
                              : "sorted-asc"
                            : ""
                        }
                      >
                        {column.render("Header")}
                        <span />
                      </th>
                    ))}
                  </tr>
                </thead>

                <tbody {...getTableBodyProps()}>
                  {rows.map((row, rowIndex) => {
                    prepareRow(row);
                    const rowId = row.original[rowIdAccessor];
                    return (
                      <tr {...row.getRowProps()}>
                        {enableBatchSelect && (
                          <td>
                            <input
                              type="checkbox"
                              checked={selectedRowIds.includes(rowId)}
                              onChange={handleSelectRow(rowId)}
                            />
                          </td>
                        )}
                        {row.cells.map((cell, cellIndex) => (
                          <td
                            key={`td_${cellIndex}`}
                            {...cell.getCellProps({
                              className: cell.column.cellClass + " listing-row",
                            })}
                          >
                            {withNumeration &&
                              cellIndex === 0 &&
                              Number(
                                (currentPage - 1) * selectedPageSize +
                                  rowIndex +
                                  1
                              )}
                            {withNumeration &&
                              cellIndex !== 0 &&
                              cell.render("Cell")}
                            {!withNumeration && cell.render("Cell")}
                          </td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              <Pagination
                currentPage={currentPage}
                totalPage={totalPage}
                onChangePage={(i) => setCurrentPage(i)}
              />
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    </>
  );
};
export default ListingTable2;
